import React, { ReactNode } from "react";
import styles from "./ToolsHeader.module.scss";

interface ToolsHeaderProps {
  header?: ReactNode;
  pagination?: ReactNode;
  preferences?: ReactNode;
  fullscreenButton?: ReactNode;
}

export const ToolsHeader = ({
  header,
  pagination,
  preferences,
  fullscreenButton,
}: ToolsHeaderProps): JSX.Element => (
  <div>
    {header}
    <div className={styles.tools}>
      <div className={styles["tools-align-right"]}>
        {pagination && <div className={styles["tools-item"]}>{pagination}</div>}
        {preferences && <div className={styles["tools-item"]}>{preferences}</div>}
        {fullscreenButton && <div className={styles["tools-item"]}>{fullscreenButton}</div>}
      </div>
    </div>
  </div>
);

ToolsHeader.defaultProps = {
  header: "",
  pagination: "",
  preferences: "",
  fullscreenButton: "",
};

export default ToolsHeader;
